angular.module('impactx.cancellation').controller('CancellationRequestSupplierCtrl', CancellationRequestSupplierCtrl);

CancellationRequestSupplierCtrl.$inject = ['$scope', 'dataGen', '$routeParams', 'ToolbarService', 'BackService', 'ToastService', '$mdDialog', 'LoadingDialogService'];

function CancellationRequestSupplierCtrl($scope, dataGen, $routeParams, ToolbarService, BackService, ToastService, $mdDialog, LoadingDialogService) {
    var ctrl = this;
    $scope.requestInProgress = false;

    var action = null;
    if ($routeParams.action) {
        action = $routeParams.action;
    }

    ctrl.getOrderLink = function () {
        return "purchaseorderdetailsupplier/" + $scope.data.pohId;
    };

    ctrl.canPerformAction = function () {
        return !$scope.readOnly && $scope.data.statusValue === 0 && !$scope.requestInProgress;
    };

    var getData = function () {
        var paramObj = {
            id: $routeParams.id
        };
        dataGen.getData($scope, paramObj, '/cancellationrequest/view/supplier').then(function () {
            $scope.buttonDefinition = [
                {
                    linkFunction: ctrl.getOrderLink,
                    label: $scope.trns.orderDetails,
                    type: 'link'
                },
                {
                    action: ctrl.accept,
                    label: $scope.trns.accept,
                    type: 'dialogaction',
                    condition: ctrl.canPerformAction
                },
                {
                    action: ctrl.reject,
                    label: $scope.trns.reject,
                    type: 'dialogaction',
                    condition: ctrl.canPerformAction
                }
            ];
            ToolbarService.setButtons($scope.buttonDefinition);

            if (ctrl.canPerformAction()) {
                if (action === 'accept') {
                    action = null;
                    ctrl.accept();
                }
                else if (action === 'reject') {
                    action = null;
                    ctrl.reject();
                }
            }
        });
    };

    ctrl.accept = function () {
        $scope.requestInProgress = true;
        LoadingDialogService.start();
        return dataGen.postAsForm({}, {crhId: $scope.data.id, usedOSU: !!action}, '/cancellationrequest/accept').then(function () {
            $scope.requestInProgress = false;
            LoadingDialogService.stop();
            ToastService.openStandardToast($scope.trns.accepted);
            BackService.back();
        }, function () {
            $scope.requestInProgress = false;
            LoadingDialogService.stop();
        });
    };

    ctrl.reject = function (event) {
        return $mdDialog.show({
            controller: 'CancelRequestRejectCommentController',
            controllerAs: 'cancelRequestRejectCommentController',
            templateUrl: 'modules/cancellation/templates/cancel-request-reject-comment-dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: true,
            locals: {
                trns: $scope.trns
            }
        }).then(function(answer) {
            $scope.requestInProgress = true;
            LoadingDialogService.start();
            dataGen.postAsForm({}, {crhId: $scope.data.id, comment: answer, usedOSU: !!action}, '/cancellationrequest/reject').then(function () {
                $scope.requestInProgress = false;
                LoadingDialogService.stop();
                ToastService.openStandardToast($scope.trns.rejected);
                BackService.back();
            }, function () {
                $scope.requestInProgress = false;
                LoadingDialogService.stop();
            });
        });
    };

    getData();
}